import { Link } from "react-router-dom";

const HotelNav = ({ selected }) => {
	const array = [
		{
			id: "snapshot",
			name: "Guests Statuses",
		},
		{
			id: "golf",
			name: "Golf",
		},
		{
			id: "sporting",
			name: "Sporting Clays",
		},
		{
			id: "welcome",
			name: "Welcome Party",
		},
		{
			id: "gift",
			name: "Gift Package",
		},
	];

	return (
		<nav style={{ marginTop: "20px" }}>
			{array.map((item) => {
				return (
					<Link
						key={item.id}
						className={
							item.id === selected ? "subpage-tab selected" : "subpage-tab"
						}
						to={
							item.id === "snapshot"
								? `/dashboard/statuses`
								: `/dashboard/statuses/${item.id}`
						}
					>
						{item.name}
					</Link>
				);
			})}
		</nav>
	);
};

export default HotelNav;
